import { render } from "./StructureThumb.vue?vue&type=template&id=35eff79c&scoped=true"
import script from "./StructureThumb.vue?vue&type=script&lang=js"
export * from "./StructureThumb.vue?vue&type=script&lang=js"

import "./StructureThumb.vue?vue&type=style&index=0&id=35eff79c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35eff79c"]])

export default __exports__